export const DEFAULT_ERROR_MESSAGE = 'backoffice.errors.default';

export const HTTP_STATUS_MESSAGES: Readonly<Record<number, string>> = {
  403: 'backoffice.errors.http.403',
  404: 'backoffice.errors.http.404',
  422: 'backoffice.errors.http.422',
  429: 'backoffice.errors.http.429',
  500: 'backoffice.errors.http.500',
  503: 'backoffice.errors.http.503',
};
